import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=742d4b55&scoped=true&"
import script from "./userAgreement.vue?vue&type=script&lang=js&"
export * from "./userAgreement.vue?vue&type=script&lang=js&"
import style0 from "./userAgreement.vue?vue&type=style&index=0&id=742d4b55&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742d4b55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\胶己人\\jjr_store_reservation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('742d4b55')) {
      api.createRecord('742d4b55', component.options)
    } else {
      api.reload('742d4b55', component.options)
    }
    module.hot.accept("./userAgreement.vue?vue&type=template&id=742d4b55&scoped=true&", function () {
      api.rerender('742d4b55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userAgreement.vue"
export default component.exports